import React from 'react';
import _ from 'lodash';
import withUpload from "../../hoc/withUpload";
import Icon from "../Icon";
import {SpinLoaderPercentage} from "../Loader";

class UploadMultipleGalleryChat extends React.Component {
    constructor(props){
        super(props);
        this.id = _.random(0, 99999);
        this.state = {
            errorMessage: '',
            preview: this.props.preview,
        };

        this.props.loadFile('',this.props.multFileData)
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if(prevProps.preview !== this.props.preview){
    //         this.setState({preview: this.props.preview});
    //         this.props.uploadFile();
    //     }
    // }

    componentWillUnmount() {
        this.props.reset();
    }

    onUploadPreviewAvailable(){
        this.setState({preview: this.props.preview});
        this.props.uploadFile();
    }

    onUploadError({response}){
        this.props.reset();
        let message = '';
        switch (response.statusCode) {
            case 413:
                message = `Fichier trop lourd, maximum accepté : ${response.errors.maxFileSizeStr}`;
                break;
            case 415:
                message = `Fichier non accepté, sont acceptés : ${response.errors.allowedTypes.join(', ')}`;
                break;
            default :
                message = 'Envoi du fichier impossible, erreur système inconnue';
                break;
        }
        this.setState({errorMessage: message, preview : ""})
    }

    render(){
        return this.props.uploading && (
            <div className="attachement-block" >
                <div className="layer"><span><Icon type="close" callback={()=>this.props.cancelUpload()}/></span></div>
                {/*<SpinLoader className={"small"} />*/}
                <SpinLoaderPercentage percentage={this.props.uploadProgress.percentCompleted}/>
                {/*<div className={"img-preview"} style={{backgroundImage: `url(${this.props.preview})`}} />*/}
                <div className={"img-preview"} style={{background: `url(${this.props.preview}) 0% 0% / cover` }} />
            </div>
        )
    }
}

export default withUpload(UploadMultipleGalleryChat);